import { Invoice } from "../models/Invoice";
import { InvoiceListReportTemplateData } from "./InvoiceListReportTemplateData";
import { InvoiceListReportImportTemplate } from "./InvoiceListReportImportTemplate";
import { cloneDeep } from "lodash";

export const getInvoiceListReportTemplate = (
        reportData: Invoice[],
        allPaidInvoices: string
    ) => {
    return InvoiceListReportImportTemplate(
        prepareData(reportData, allPaidInvoices)
    );
};

const prepareData = (reportData: Invoice[], allPaidInvoices: string) => {
    const templateData: InvoiceListReportTemplateData = {
        reportData: (cloneDeep(reportData)).sort((a: Invoice, b: Invoice) => a.createdAt < b.createdAt ? 1 : -1),
        allPaidInvoices: allPaidInvoices
    };

    return templateData;
};